export function LoginFooter() {
  return (
    <iframe
      src="https://gotland.se/rg/almedalsveckan/ovrigt/sidfot-almedalsveckan"
      title="Sidfot"
      scrolling="no"
      className="
        block
        w-full
        border-0
        h-[1250px]
        min-[375px]:h-[1216px]
        min-[425px]:h-[1226px]
        sm:h-[1226px]
        md:h-[1257px]
        lg:h-[782px]
        xl:h-[865px]
        2xl:h-[1089px]
      "
    />
  );
}